export default Object.freeze({
    COMPANY_NAME: 'Marketing Services International',
    BANK_ACCOUNT_HOLDER: 'Marketing Services International B.V',
    SORT_CODE: '23-14-70',
    ACCOUNT_NUMBER: '53763821',
    BITCOIN_WALLET: '33JXUMXVqF3sWKWqLG2V78mwoGv7Bba5C8',
});
